export default "__VITE_ASSET__BHDr5shl__"